var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDateIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26909",
    "data-name": "Group 26909",
    transform: "translate(-13603 8384)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_6363",
    "data-name": "Rectangle 6363",
    transform: "translate(13603 -8384)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 10,
    height: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "icons8-tear-off-calendar",
    d: "M14.5,7.889V7.535A1.536,1.536,0,0,0,12.965,6H7.535A1.536,1.536,0,0,0,6,7.535v.354ZM6,8.6v4.368A1.536,1.536,0,0,0,7.535,14.5h5.431A1.536,1.536,0,0,0,14.5,12.965V8.6Zm6.611,3.542a.472.472,0,0,1-.472.472h-.944a.472.472,0,0,1-.472-.472v-.944a.472.472,0,0,1,.472-.472h.944a.472.472,0,0,1,.472.472Z",
    transform: "translate(13598.25 -8388.75)",
    fill: "#6d809f"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDateIcon);
export default __webpack_public_path__ + "static/media/dateIcon.6dcc41286ff67d816b820d13da8e723e.svg";
export { ForwardRef as ReactComponent };